import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import moment from 'moment';
import Header from '../../components/Header';
import {
  formatter,
  getSelectedTeamName,
  onGoBack
} from '../../common/globals';
import withGoBack from '../../common/withGoBack';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withTeam from '../../common/withTeam';
import withOnline from '../../common/withOnline';
import withUser from '../../common/withUser';
import withTableName from '../../common/withTableName';
import {
  generateTimedURL,
  caseBillingDetails,
  listSingleCase
} from '../../utils/utils';
import {
  getTableCaseByCaseId,
  getCaseByCaseScheduleID,
  singleManageCaseAdd
} from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';

class BillingDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      priceList: [],
      billingData: [],
      billingCount: 0,
      billingTotal: 0,
      isPriceSheetShow: false,
      copiedUrl: '',
      caseDetail: {},
    };
    this.onlineAlertModal = null;
  }

  _onPriceList = async () => {
    try {
      const {
        user, setLoader, params: { caseId }, tableName
      } = this.props;
      const caseDetailsRes = await getTableCaseByCaseId(caseId, tableName);
      const generateTimedURLData = {
        team: await getSelectedTeamName(),
        entity_type: 'pricesheets',
        entity_id: caseDetailsRes.RepCaseNo,
        token: user.token,
        key: user.userKey
      };
      setLoader(true);
      generateTimedURL(generateTimedURLData).then((response) => {
        setLoader(false);
        const { result, data } = response;
        if (result === 'success') {
          this.setState({ isPriceSheetShow: true, copiedUrl: data });
          return false;
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenPriceList = () => {
    try {
      const { copiedUrl } = this.state;
      window.open(copiedUrl, '_blank', 'fullscreen=yes');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getBillingDetails = async () => {
    try {
      const {
        params: { caseId }, online, notify, setLoader, tableName
      } = this.props;
      const caseDetailsRes = await getTableCaseByCaseId(caseId, tableName);
      if (online) {
        setLoader(true);
        caseBillingDetails(caseDetailsRes.CaseScheduleID).then((response) => {
          setLoader(false);
          // console.log(response);
          const { status, message, data } = response;
          if (status) {
            if (message.length > 0) {
              // notify({ type: 'success', message });
            }
            if (data) {
              this.setState({
                billingData: data.billing_details,
                billingCount: data.billing_details.length,
                billingTotal: data.totalBilling
              });
            }
          } else {
            notify({ type: 'error', message });
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCase = async () => {
    const {
      params: { caseId }, tableName, setLoader, notify
    } = this.props;
    try {
      setLoader(true);
      // Check if the case is already in the db
      const caseResByCaseId = await getTableCaseByCaseId(caseId, tableName);
      if (caseResByCaseId) {
        setLoader(false);
        return caseResByCaseId;
      }

      // Check if the case is already in the db by schedule id
      const caseResByScheduleId = await getCaseByCaseScheduleID(Number(caseId));
      if (caseResByScheduleId) {
        setLoader(false);
        return caseResByScheduleId;
      }

      // If case is not in the db, fetch from remote
      const caseResFromRemote = await listSingleCase(caseId);
      if (!caseResFromRemote?.data?.length) {
        notify({ type: 'error', message: 'Case not found in currently active team.' });
        browserHistory.push('/manage-cases');
        return;
      }
      const resId = await singleManageCaseAdd(caseResFromRemote.data[0]);
      const caseSavedToDb = await getTableCaseByCaseId(resId, tableName);
      if (caseSavedToDb) {
        setLoader(false);
        return caseSavedToDb;
      }
    } catch (e) {
      Bugsnag.notify(e);
    } finally {
      setLoader(false);
    }
  }

  _getCaseById = async () => {
    try {
      const { notify } = this.props;
      const caseRes = await this._getCase();
      // console.log(caseRes);
      if (Object.keys(caseRes).length > 0) {
        this.setState({
          caseDetail: caseRes
        });
      } else {
        notify({ type: 'error', message: 'Case record not found.' });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { params } = this.props;
      if (params.hasOwnProperty('caseId')) {
        await this._getCaseById();
      }

      await this._getBillingDetails();
      await this._onPriceList();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { goBack } = this.props;
    const {
      billingData, billingCount, billingTotal, isPriceSheetShow
    } = this.state;
    let POIssueFlag = '0';
    if (billingData.length > 0) {
      for (const item of billingData) {
        if (item.POIssue === '1') {
          POIssueFlag = '1';
        }
      }
    }
    // console.log(caseDetail);
    // console.log(billingData);
    return (
      <div className="site-wrapper">
        <Header
          title="Billing Details"
          goBack={() => onGoBack(goBack)}
        />
        <section className="case-details-section">
          <div className="container">
            <div className="row gx-2">
              <div className="col-8 col-md-3">
                <div className="case-data">
                  <h6>
                    <strong>{billingCount} {(billingCount === 0) ? 'POs' : (billingCount === 1) ? 'PO' : 'POs'}</strong>
                    <span className="error btn-ml">
                      {/* { (typeof caseDetail.POIssue !== 'undefined'
                      && caseDetail.POIssue !== null)
                      ? ((caseDetail.POIssue === '0')
                      ? '' : ' *Case is flagged') : ''} */}
                      {(POIssueFlag === '0') ? '' : ' *Case is flagged'}
                    </span>
                  </h6>
                </div>
                <div className="case-data">
                  <label htmlFor="totalAmount">Total Amount</label>
                  <p>{formatter.format(billingTotal)}</p>
                </div>
              </div>
              {
                isPriceSheetShow === true
                && (
                  <div className="col-4 col-md-3">
                    <Link
                      className="btn btn-theme-alt btn-theme-outline-alt d-block"
                      id="text-container"
                      onClick={this._onOpenPriceList}
                    >Price Sheet
                    </Link>
                  </div>
                )
              }
            </div>
            <hr />
            {
              billingData.length > 0 && billingData.map((item, key) => (
                <div className="row gx-2" key={key}>
                  <div className="col-12 col-md-12">
                    <div className="case-data">
                      <h6><strong>PO #{key + 1}</strong>
                        {/* <span className="error">
                          {(item.POIssue === '0') ? '' : ' *There is an issue with this PO'}
                        </span> */}
                      </h6>
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="case-data">
                      <label htmlFor="amount">Amount</label>
                      <p>${item.Amount}</p>
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="case-data">
                      <label htmlFor="po">PO #</label>
                      <p>{item.PONumber}</p>
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="case-data">
                      <label htmlFor="poDate">PO Date</label>
                      <p>{item.PODate !== null ? moment(item.PODate).format('MMM DD, YYYY') : '-'}</p>
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="case-data">
                      <label htmlFor="billDate">Bill Date</label>
                      <p>{item.BilledDate !== null ? moment(item.BilledDate).format('MMM DD, YYYY') : '-'}</p>
                    </div>
                  </div>
                </div>
              ))
            }
            {/* <hr /> */}
          </div>
        </section>
      </div>
    );
  }
}

export default withTableName(
  withTeam(
    withNotify(
      withOnline(
        withLoader(
          withUser(
            withGoBack(
              BillingDetail
            )
          )
        )
      )
    )
  )
);
